import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { MultiSelect } from 'primereact/multiselect';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Grid from '@mui/material/Grid';
import { ConfirmDialog } from 'primereact/confirmdialog'; // For <ConfirmDialog /> component
import { confirmDialog } from 'primereact/confirmdialog'; // For confirmDialog method

import moment from "moment";

import multiPaymentsIcon from '../../Assets/Images/multiPaymentsIcon.svg';

import titleTrainIcon from '../../Assets/Images/titleTrainIcon.svg';
import titleBusIcon from '../../Assets/Images/titleBusIcon.svg';
import titleTransferIcon from '../../Assets/Images/titleBusIcon.svg';
import titleRentCarIcon from '../../Assets/Images/titleBusIcon.svg';

// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as ReservationActions from '../../Store/Actions/Reservation'

import AboutUs from '../../Components/layout/AboutUs';
import ContactUs from '../../Components/layout/ContactUs';

// Load Componentes
import SideMenu from '../../Components/SideMenu';
import MessageView from '../../Components/MessageModal';
import AlertView from '../../Components/AlertModal';
import ReservationView from './ReservationModal';
import ReservationMultiPayView from './ReservationMulitplePayModal';

import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	maskCNPJ,
	maskCPF,
	maskPhone
} from '../../Components/Utils';

import {
	Callto,
	Whatsapp,

} from '../../Components/Utils';

// export default function Reservation() {
const Reservation = (props) => {
	
// Set var from props
const {
	setDialog,
	dialog,
	setReservation,
	selectedReservation,
	retrieveReservations,
	masterUser,
	userRights
} = props;

console.log('[userRights]--------->]'+JSON.stringify(userRights, null, 2));
console.log('[masterUser]--------->]'+JSON.stringify(masterUser, null, 2));

// Set Overlay obj
const op = React.useRef(null);

const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isSpecialDesktop = useMediaQuery({ query: '(max-width: 1500px)' })

const [stillConnected, setStillConnected] = React.useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

// Basic filter fields  and controls
const [basicFilterStatus, setBasicFilterStatus] = React.useState(false);
const [basicFilter, setBasicFilter] = React.useState({});
const [filterValue, setFilterValue] = React.useState("");

// Advanced filter fields and controls
const [advancedFilterStatus, setAdvancedFilterStatus] = React.useState(false);
const [advancedFilter, setAdvancedFilter] = React.useState({});
const [advancedSearch, setAdvancedSearch] = React.useState(false);

// CUSTOM ADVANCED FILTER FIELDS
const [filterByReservationId, setFilterByReservationId] = React.useState("");
const [filterByAgencyName, setFilterByAgencyName] = React.useState("");
const [filterByAgencyDocument, setFilterByAgencyDocument] = React.useState("");
const [filterByCustomerName, setFilterByCustomerName] = React.useState("");
const [filterByGuestName, setFilterByGuestName] = React.useState("");

const [filterByCustomerDocument, setFilterByCustomerDocument] = React.useState("");
const [filterByUserName, setFilterByUserName] = React.useState("");
const [filterByTransportType, setFilterByTransportType] = React.useState([]);
const [filterByCreateAtFrom, setFilterByCreateAtFrom] = React.useState("");
const [filterByCreateAtTo, setFilterByCreateAtTo] = React.useState("");

const [filterByCheckinDateFrom, setFilterByCheckinDateFrom] = React.useState("");
const [filterByCheckinDateTo, setFilterByCheckinDateTo] = React.useState("");

const [filterByCheckoutDateFrom, setFilterByCheckoutDateFrom] = React.useState("");
const [filterByCheckoutDateTo, setFilterByCheckoutDateTo] = React.useState("");

const [filterByCancellationDeadlineFrom, setFilterByCancellationDeadlineFrom] = React.useState("");
const [filterByCancellationDeadlineTo, setFilterByCancellationDeadlineTo] = React.useState("");

const [filterByPaymentMethod, setFilterByPaymentMethod] = React.useState(null);
const [filterByStatus, setFilterByStatus] = React.useState(null);
const [filterByBookingStatus, setFilterByBookingStatus] = React.useState(null);

// Table row selection
const [selectedItem, setSelectedItem] = React.useState(null);
const [selectedBookings, setSelectedBookings] = React.useState([]);
const [selectedBookingsStore, setSelectedBookingsStore] = React.useState([]); // armazena objetos completos referente a seleção do checkbox


const handleCheckboxChange = (value) => {

	const selectedRow = (Array.isArray(value) && value.length > 0) ? value[0] : value;

	// Only add if value.status == 1
	if (!selectedRow.status) {
		if (selectedBookings.includes(selectedRow.reservationId)) {
			setSelectedBookings(selectedBookings.filter(id => id !== selectedRow.reservationId));
			setSelectedBookingsStore(selectedBookingsStore.filter(item => item.reservationId !== selectedRow.reservationId));
		} else {
		setSelectedBookings([...selectedBookings, selectedRow.reservationId]);
		setSelectedBookingsStore([...selectedBookingsStore, selectedRow]);
		}
	}

}

const handleRowCheckboxChange = (value) => {

	const selectedRow = (Array.isArray(value) && value.length > 0) ? value[0] : value;

	// Only add if value.status == 1
	if (!selectedRow.status) {
		if (selectedBookings.includes(selectedRow.reservationId)) {
			setSelectedBookings(selectedBookings.filter(id => id !== selectedRow.reservationId));
			setSelectedBookingsStore(selectedBookingsStore.filter(item => item.reservationId !== selectedRow.reservationId));
		} else {
		setSelectedBookings([...selectedBookings, selectedRow.reservationId]);
		setSelectedBookingsStore([...selectedBookingsStore, selectedRow]);
		}
	}

}

const resetSelection = () => {
  setSelectedBookings([]);
  setSelectedBookingsStore([]);
}

const payMultipleBooking = (event) => {
  try {
    // helpers
    const onlyDigits = (doc) => (doc || "").toString().replace(/\D/g, "");
    const toIdStr = (v) => (v == null ? "" : String(v));
  
    // validações básicas
    if (!Array.isArray(selectedBookings) || selectedBookings.length === 0) {
      setAlert(true);
      setAlertTitle("Atenção");
      setAlertBody("Nenhuma reserva selecionada para pagamento único de múltiplas reservas.");
      return;
    }

    if (!Array.isArray(selectedBookingsStore) || selectedBookingsStore.length === 0) {
      setAlert(true);
      setAlertTitle("Atenção");
      setAlertBody("Nenhuma reserva selecionada para pagamento único de múltiplas reservas.");
      return;
    }


    if (selectedBookingsStore.length === 1) {
      setAlert(true);
      setAlertTitle("Atenção");
      setAlertBody("Você selecionou apenas uma reserva. Para pagar uma única reserva, utilize o botão de pagamento localizado nas ações ao visualizar a reserva.");
      return;
    }


    // normaliza ids selecionados para string (evita comparar number vs string)
    const selectedIds = new Set(selectedBookings.map(toIdStr));

    // saneia o store: remove itens nulos e sem reservationId
    const cleanedStore = selectedBookingsStore.filter(
      (b) => b && typeof b === "object" && b.reservationId != null
    );

    // filtra apenas as reservas do store que estão nos selecionados
    const bookings = cleanedStore.filter((b) =>
      selectedIds.has(toIdStr(b.reservationId))
    );

    // checa se alguma id selecionada não foi encontrada no store
    if (bookings.length !== selectedIds.size) {
      const foundIds = new Set(bookings.map((b) => toIdStr(b.reservationId)));
      const missing = [...selectedIds].filter((id) => !foundIds.has(id));
      setAlert(true);
      setAlertTitle("Atenção");
      setAlertBody(
        `As seguintes reservas selecionadas não foram encontradas: ${missing.join(", ")}.`
      );
      return;
    }

    // coleta/normaliza documentos
    const agencyDocs = bookings.map((b) => ({
      id: b.reservationId,
      raw: b?.agency?.document || "",
      norm: onlyDigits(b?.agency?.document),
    }));

    const customerDocs = bookings.map((b) => ({
      id: b.reservationId,
      raw: b?.customer?.document || "",
      norm: onlyDigits(b?.customer?.document),
    }));


    // checa igualdade de todos os docs
    const uniqAgency = new Set(agencyDocs.map((a) => a.norm));
    const uniqCustomer = new Set(customerDocs.map((c) => c.norm));

    if (uniqAgency.size > 1 || uniqCustomer.size > 1) {
      setAlert(true);
      setAlertTitle("Não foi possível prosseguir");
      setAlertBody(
        masterUser ? "Para pagamento único de múltiplas reservas, é necessário que TODAS as reservas sejam do mesmo cliente e da mesma agência." : "Para pagamento único de múltiplas reservas, é necessário que TODAS as reservas sejam do mesmo cliente / responsável pelo pagamento." );
      return;
    }

	// Verifica se um ou mais registro tem o responsavel pelo pagamento nos hospedes e se ha restricao de pagamento
	const blockPayment = bookings.some(b => b?.customer?.isHost === false && b?.applyPaymentRestrictions === true);
	if (blockPayment) {
		setAlert(true);
		setAlertTitle("Atenção");
		setAlertBody("Um ou mais registros selecionados possuem restrições de pagamento pois o responsável pelo pagamento não é um dos hóspedes. Entre em contato com o suporte para retirar a restrição ou alterar o responsável pelo pagamento.");
		return;
	}

    // se chegou aqui, pode pagar
    console.log("Pagar mais de uma reserva:", bookings);
	confirmMulti(event);

  } catch (err) {
    console.error(err);
    setAlert(true);
    setAlertTitle("Erro inesperado");
    setAlertBody("Ocorreu um erro ao processar o pagamento múltiplo. Tente novamente.");
  }
};

/* confirm booking prompt START  */
const accept = (item) => {

	console.log('[item]--------->]'+JSON.stringify(item, null, 2));
	console.log('CONFIRM PAYMENT');
};

const reject = (e) => {
	//op.current.toggle(e);
};

const confirm = (event,item) => {

	// Avoid onclick event on parent
	event.stopPropagation();

	confirmDialog({
		target: event.currentTarget,
		header: 'Confirmação de Pagamento',
		message: <div style={{maxWidth:"30rem"}}>Tem certeza que deseja iniciar o pagamento dessa reserva? <br /><br />Lembre-se que você tem que ter em mãos o cartão de crédito do responsável pelo pagamento da reserva.</div>,
		icon: 'pi pi-exclamation-triangle',
		accept: () => accept(item),
		reject,
		dismissableMask:true,
		blockScroll:true,
		rejectLabel:"Não, farei isso depois.",
		acceptLabel:"Sim, vou prosseguir!"
	});
};
/* confirm booking prompt END  */

/* confirm booking prompt START  */
const acceptMulti = (e) => {
	  setDialog('reservationMultiPayModal',true);
};

const rejectMulti = (e) => {
	//op.current.toggle(e);
};

const confirmMulti = (event) => {
	confirmDialog({
		target: event.currentTarget,
		header: 'Confirmação de Pagamento',
		message: <div style={{maxWidth:"30rem"}}>Tem certeza que deseja iniciar o pagamento das reservas selecionadas? <br /><br />Lembre-se que você tem que ter em mãos o cartão de crédito do responsável pelo pagamento das reservas.</div>,
		icon: 'pi pi-exclamation-triangle',
		accept: acceptMulti,
		reject: rejectMulti,
		dismissableMask:true,
		blockScroll:true,
		rejectLabel:"Não, farei isso depois.",
		acceptLabel:"Sim, vou prosseguir!"
	});
};
/* confirm booking prompt END  */

// Set Fake Data
//var rowsData = ReservationData;
const [rows, setRows] = React.useState([]);
const [totalRecords, setTotalRecords] = React.useState(0);
 
/* -------------------------------- */ 
/* Custom methods and options START */
/* -------------------------------- */

// Select reservation item method
const selectReservationAction = (value) => {

	// Check if its an array or object and delegate
	const normalizedValue = Array.isArray(value) ? value : [value];

	//var rID = value.reservationId;	
	setSelectedItem(normalizedValue?.[0]?.reservationId || null);

	// Set reservation on store (index 0)
	setReservation(normalizedValue?.[0] || null);

	// Open Modal
	setDialog('reservationModal',true);
	
}

// Retrieve reservations
const retrieveItemsList = () => {
		
	var props = {
		setSaving:setSaving,
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody,
		setRows:setRows,
		setLoading:setLoading,
		setTotalRecords:setTotalRecords
	}
	var data = {
	  ...lazyState
	}
	retrieveReservations(data,props);

} // end retrieveDocumentInfo

// Dropdown Values for Basic Search Fields
const [filter, setFilter] = React.useState({
	"code": "1",
	"field":"reservationId",
	"name": "Nº interno"
  });
  
const FilterItems = masterUser ? [
    {
	"code": "1",
	"field":"reservationId",
	"name": "Nº interno"
  },
  {
	"code": "5",
	"field":"agencyName",
	"name": "Nome da Agência"
  },  
  {
	"code": "2",
	"field":"customerName",
	"name": "Nome do Cliente"
  },   
  {
	"code": "3",
	"field":"customerDocument",
	"name": "CPF do Cliente"
  },     
   { 
	"code": "4",
	"field":"userName",
	"name": "Nome do Usuário"
  }
] : [
  {
	"code": "1",
	"field":"reservationId",
	"name": "Nº interno"
  },
  {
	"code": "2",
	"field":"customerName",
	"name": "Nome do Cliente"
  },   
  {
	"code": "3", 
	"field":"customerDocument",
	"name": "CPF do Cliente"
  },    
  { 
	"code": "4",
	"field":"userName",
	"name": "Nome do Usuário"
  }
];
const [dropdownFilterItems, setDropdownFilterItems] = React.useState(FilterItems);

// Datatable default state
const [lazyState, setlazyState] = React.useState({
	first: 0,
	rows: 25,
	page: 1,
	sortField: "createdAt",
	sortOrder: -1,
	filters: {
	}
});

// Default columns
const columnsValues = masterUser ? [
'reservationId',
'agency',
'user',
'customer',
'locality',
'checkinDate',
'payment',
'createdAt',
'status',
'actions'
] : [
'reservationId',
'user',
'customer',
'locality',
'checkinDate',
'payment',
'createdAt',
'status',
'actions'
];
const [visibleColumns, setVisibleColumns] = React.useState(columnsValues);

// Field value format and enrichement
const bodyTemplate = (type,data) => {

	let rowValue = "Não definido";

	if (type == "reservationId") {

		rowValue = (
		<>
		<div>{data.reservationId} 		
		
		{data.origin == "master" &&
			<svg fill="#814DE5" viewBox="0 0 1920 1920" style={{marginLeft:"5px"}} width="15" height="auto" xmlns="http://www.w3.org/2000/svg" stroke="#814DE5"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M983.727 5.421 1723.04 353.62c19.765 9.374 32.414 29.252 32.414 51.162v601.525c0 489.6-424.207 719.774-733.779 887.943l-34.899 18.975c-8.47 4.517-17.731 6.889-27.105 6.889-9.262 0-18.523-2.372-26.993-6.89l-34.9-18.974C588.095 1726.08 164 1495.906 164 1006.306V404.78c0-21.91 12.65-41.788 32.414-51.162L935.727 5.42c15.134-7.228 32.866-7.228 48 0ZM757.088 383.322c-176.075 0-319.285 143.323-319.285 319.398 0 176.075 143.21 319.285 319.285 319.285 1.92 0 3.84 0 5.76-.113l58.504 58.503h83.689v116.781h116.781v83.803l91.595 91.482h313.412V1059.05l-350.57-350.682c.114-1.807.114-3.727.114-5.647 0-176.075-143.21-319.398-319.285-319.398Zm0 112.942c113.732 0 206.344 92.724 205.327 216.62l-3.953 37.271 355.426 355.652v153.713h-153.713l-25.412-25.299v-149.986h-116.78v-116.78H868.108l-63.812-63.7-47.209 5.309c-113.732 0-206.344-92.5-206.344-206.344 0-113.732 92.612-206.456 206.344-206.456Zm4.98 124.98c-46.757 0-84.705 37.948-84.705 84.706s37.948 84.706 84.706 84.706c46.757 0 84.706-37.948 84.706-84.706s-37.949-84.706-84.706-84.706Z" fill-rule="evenodd"></path> </g></svg>
		}</div>
		</>
		);	
		
	}
	
	if (type == "agency") {		

		rowValue = (
		<>
		<div>{data.name}</div>
		<div><small style={{color:"gray"}}>{data.document}</small></div>
		</>
		);	
		
	}
	
	if (type == "customer") {	
			
		rowValue = (
		<>
		<div>{data.name}</div>
		<div><small style={{color:"gray"}}>{data.document}</small></div>
		</>
		);				
	}	
	
	if (type == "employee") {	

		rowValue = (
		<>
		<div>{data.name}</div>
		<div><small style={{color:"gray"}}>{data.document}</small></div>
		</>
		);	
	}	

	if (type == "locality") {		

		rowValue = (
		<>
		{/*<div>{label} <img src={transportIcon} style={{marginLeft:"5px",width:"18px",height:"auto"}} className="noSelect" /></div>*/}
		<div>
			<div><strong>{data?.locality?.property?.propertyName || "-"}</strong></div>
			<div>{data?.locality?.destination?.country?.label || ""}, {data?.locality?.destination?.city || ""}</div>
		</div>
		</>
		);	
	}	

	if (type == "checkinDate") {	
		rowValue = moment(data.checkinAt).format("DD/MM/YYYY")
	}		

	if (type == "checkoutDate") {		
		rowValue = moment(data.checkoutAt).format("DD/MM/YYYY")
	}

	if (type == "creationDate") {		
		rowValue = moment(data.createdAt).format("DD/MM/YYYY")
	}	


	if (type == "payment") {	
		
		
		// Set data payment
		const dataPayment = data.payment;

		if (dataPayment.paymentMethod == "pix" ) {
			var icon = (<svg fill="#814DE5" viewBox="0 0 16 16"  width="20" height="20" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M11.917 11.71a2.046 2.046 0 0 1-1.454-.602l-2.1-2.1a.4.4 0 0 0-.551 0l-2.108 2.108a2.044 2.044 0 0 1-1.454.602h-.414l2.66 2.66c.83.83 2.177.83 3.007 0l2.667-2.668h-.253zM4.25 4.282c.55 0 1.066.214 1.454.602l2.108 2.108a.39.39 0 0 0 .552 0l2.1-2.1a2.044 2.044 0 0 1 1.453-.602h.253L9.503 1.623a2.127 2.127 0 0 0-3.007 0l-2.66 2.66h.414z"></path><path d="m14.377 6.496-1.612-1.612a.307.307 0 0 1-.114.023h-.733c-.379 0-.75.154-1.017.422l-2.1 2.1a1.005 1.005 0 0 1-1.425 0L5.268 5.32a1.448 1.448 0 0 0-1.018-.422h-.9a.306.306 0 0 1-.109-.021L1.623 6.496c-.83.83-.83 2.177 0 3.008l1.618 1.618a.305.305 0 0 1 .108-.022h.901c.38 0 .75-.153 1.018-.421L7.375 8.57a1.034 1.034 0 0 1 1.426 0l2.1 2.1c.267.268.638.421 1.017.421h.733c.04 0 .079.01.114.024l1.612-1.612c.83-.83.83-2.178 0-3.008z"></path></g></svg>)
						var label = "PIX";
		} // end if
		else {
			var icon = (<svg fill="#814DE5" viewBox="0 0 32 32" width="20" height="20" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M29.005 5.5h-26.009c-1.657 0-3 1.343-3 3v15c0 1.657 1.343 3 3 3h26.009c1.657 0 3-1.343 3-3v-15c0-1.657-1.343-3-3-3zM2.995 7.5h26.009c0.552 0 1 0.448 1 1v2h-28.009v-2c0-0.552 0.449-1 1-1zM29.005 24.5h-26.009c-0.552 0-1-0.448-1-1v-9h28.009v9c0 0.552-0.448 1-1 1z"></path> </g></svg>);
			var label = "Cartão de crédito";
		} // end else

		
		rowValue = (
		<>
		{(dataPayment.status == 1 && dataPayment.multiPayment == 0) &&
		<>
			<div style={{fontSize:dataPayment.status == 1 ? "0.65rem" : "0.85rem",color:"gray"}}>{USD.format(dataPayment.originalAmount)}</div>

			<div style={{fontSize:"0.85rem"}}>{BRL.format(dataPayment.totalAmount)}</div>
			{dataPayment.paymentMethod == "cc" && <div style={{fontSize:"0.85rem",color:"gray"}}>{dataPayment?.installments?.length || 1}x sem juros</div>}
			<div style={{marginTop:"3px",display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center",gap:"5px",fontSize:"0.85rem"}}>
				{icon}
				<small>{label}</small>
			</div>
		</>
		}
		{(dataPayment.status == 1 && dataPayment.multiPayment == 1) &&
		<>
			<div style={{fontSize:dataPayment.status == 1 ? "0.65rem" : "0.85rem",color:"gray"}}>{USD.format(dataPayment.originalAmount)}</div>

			<div style={{fontSize:"0.85rem"}}>{BRL.format(dataPayment.originalAmount * dataPayment.exchangeRate)} <small style={{color:"#6e6e6e"}}>de {BRL.format(dataPayment.multiPaymentTotalAmount)}</small></div>
			<div style={{fontSize:"0.85rem",color:"gray"}}>Pagamento em conjunto</div>
			<div style={{marginTop:"3px",display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center",gap:"5px",fontSize:"0.85rem"}}>
				{icon}
				<small>{label}</small>
			</div>
		</>
		}
		{dataPayment.status != 1 &&
		<>
			<div style={{fontSize:"0.85rem"}}>{USD.format(dataPayment.originalAmount)}</div>
		</>	
		}	

		</>
		);		
		
	}	

	if (type == "status") {		


		if (data.paymentStatus == 0) {
			var activationStatus = "waiting";
			var activationStatusLabel = "Aguardando Pagamento";
		} // end if	
		else if (data.paymentStatus == 1) {
			var activationStatus = "confirmed";
			var activationStatusLabel = "Pagamento Confirmado";
		} // end if
		else if (data.paymentStatus == 2) {
			var activationStatus = "waiting";
			var activationStatusLabel = "Aguardando reembolso";
		} // end if	
		else if (data.paymentStatus == 3) {
			var activationStatus = "info";
			var activationStatusLabel = "Reembolso confirmado";	
		} // end if			
		else {
			var activationStatus = "info";
			var activationStatusLabel = "Status indefinido";			
		}

		// 0 - Pendente Confirmação, 1 - Confirmada, 2 - Reembolsada, 3 - Parcialmente Reembolsada, 9 - Cancelada

		let bookingStatus, bookingStatusLabel;
		if (data.bookingStatus == 0 ) {
			bookingStatus = "waiting";
			bookingStatusLabel = "Aguardando confirmação";
		} else if (data.bookingStatus == 1) {
			bookingStatus = "confirmed";
			bookingStatusLabel = "Reserva Confirmada";
		} else if (data.bookingStatus == 2) {
			bookingStatus = "cancelled";
			bookingStatusLabel = "Cancelada pelo sistema";
		} else if (data.bookingStatus == 3) {
			bookingStatus = "cancelled";
			bookingStatusLabel = "Cancelada pela agência";
		} else {
			bookingStatus = "cancelled";
			bookingStatusLabel = "Status Desconhecido";
		}

		// --- NOVO: regra dos 15 dias ---
		const hasLimit = !!data?.payment?.limitPaymentDate;
		const today = moment().startOf("day");
		const limit = hasLimit ? moment(data.payment.limitPaymentDate).startOf("day") : null;
		const daysToLimit = hasLimit ? limit.diff(today, "days") : Infinity; // negativo = atrasado
		const isDueSoonOrOverdue = hasLimit && daysToLimit <= 15; // 15 dias ou menos (inclui hoje e atrasados)

		return (
			<>
			<div style={{ marginBottom: "1rem" }} className={`product-badge status-${bookingStatus}`}>
				{bookingStatusLabel}
			</div>

			{( (data.paymentStatus == 0 && data.bookingStatus == 1) || (data.paymentStatus == 1 && data.bookingStatus == 1) || ((data.paymentStatus == 2 || data.paymentStatus == 3) && data.bookingStatus == 3) ) &&
			<div className={`product-badge status-${(isDueSoonOrOverdue && hasLimit && !data.status) ? "alert" : activationStatus}`}>
				{activationStatusLabel}
			</div>
			}

			{(!data.status && hasLimit && (data.paymentStatus == 0 && data.bookingStatus == 1)) && (
				<div>
				<small style={{ color: isDueSoonOrOverdue ? "red" : "inherit" }}>
					Data limite {moment(data.payment.limitPaymentDate).format("DD/MM/YYYY")}
				</small>
				</div>
			)}
			</>
		);
	
	}

	if (type == "actions") {

		return (
			<div className="flex-row justify-start align-items-center">
				{!masterUser && <Button icon="pi pi-eye" className="p-button-rounded p-button-text" onClick={() => selectReservationAction(data)} />}	
				{/*((!data.status && data.bookingStatus == 1) && !masterUser) && (<Button icon="pi pi-dollar" className="p-button-rounded p-button-text" onClick={(e) => {confirm(e,data)}} />)*/}
			</div>
		)
	}

	if (type == "selectionCheckbox") {

		return (
			<div className="flex-row justify-center align-items-center">
				{((!data.status && data.bookingStatus == 1) && !masterUser)  && 
				<>
					{(userRights.includes("payMultipleBookings") || userRights.includes("all")) &&
					<Checkbox inputId={data.reservationId} value={data.reservationId} onChange={() => handleCheckboxChange(data)} checked={selectedBookings.includes(data.reservationId)} />
					}
				</>	
				}
			</div>
		)
	}

    return rowValue;
};
 
const applyBasicSearch = () => {
	
	// Check if search term is filled and with at least 3 chars
	if (!filterValue) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Você precisa preencher o termo a ser buscado pra prosseguir.");	
		return;
	} // end if

	if (filterValue.length < 3 && filter.field != "reservationId") {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Para prosseguir, você precisa preencher o termo a ser buscado com ao menos 3 caracteres.");	
		return;
	} // end if	
 	
	// Set filter on
	setBasicFilterStatus(true);
	
	// Set advanced filter off
	setAdvancedFilterStatus(false);
	
	// Clean Advanced fields
	setFilterByReservationId("");
	setFilterByAgencyName("");
	setFilterByAgencyDocument("");
	setFilterByCustomerName("");
	setFilterByGuestName("");
	setFilterByCustomerDocument("");
	setFilterByUserName("");
	setFilterByTransportType([]);
	setFilterByCreateAtFrom("");
	setFilterByCreateAtTo("");
	setFilterByCheckinDateFrom("");
	setFilterByCheckinDateTo("");
	setFilterByCheckoutDateFrom("");
	setFilterByCheckoutDateTo("");

	setFilterByCancellationDeadlineFrom("");
	setFilterByCancellationDeadlineTo("");

	setFilterByPaymentMethod("");
	setFilterByStatus("");
	setFilterByBookingStatus("");

	// Set filter to lazyData
	var currentData = {...lazyState}
	
	// Set current filter
	currentData.filters = {
		mode:"basic",
		term: filterValue,
		field: filter
	}
	
	// Set LazyState
	setlazyState(currentData);
	
} // end function

const resetSearch = (type)=> {
	
	if (type == "basic") {
		// Set filter on
		setBasicFilterStatus(false);
		
		// Clean Terms
		setFilterValue("");		
	} // end if
	else {
		// Set filter on
		setAdvancedFilterStatus(false);
		
		setFilterByReservationId("");
		setFilterByAgencyName("");
		setFilterByAgencyDocument("");
		setFilterByCustomerName("");
		setFilterByGuestName("");
		setFilterByCustomerDocument("");
		setFilterByUserName("");
		setFilterByTransportType([]);
		setFilterByCreateAtFrom("");
		setFilterByCreateAtTo("");
		setFilterByCheckinDateFrom("");
		setFilterByCheckinDateTo("");
		setFilterByCheckoutDateFrom("");

		setFilterByCancellationDeadlineFrom("");
		setFilterByCancellationDeadlineTo("");		

		setFilterByCheckoutDateTo("");
		setFilterByPaymentMethod("");
		setFilterByStatus("");	
		setFilterByBookingStatus("");	
		
	} // end else
	
	// Set filter to lazyData
	var currentData = {...lazyState}
	
	// Set current filter
	currentData.filters = {};
	
	// Set LazyState
	setlazyState(currentData);	
	
} // end fucntion

const applyAdvancedSearch = () => {
	
	// Check if at least one field is filled
	if (!filterByReservationId && !filterByAgencyName && !filterByAgencyDocument && !filterByCustomerName && !filterByGuestName && !filterByCustomerDocument && !filterByUserName && filterByTransportType.length == 0 &&  !filterByCreateAtFrom && !filterByCreateAtTo && !filterByCheckinDateFrom && !filterByCheckinDateTo && !filterByCheckoutDateFrom && !filterByCheckoutDateTo && !filterByPaymentMethod && !filterByStatus && !filterByBookingStatus && !filterByCancellationDeadlineFrom && !filterByCancellationDeadlineTo) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Você precisa preencher ao menos um campo pra prosseguir com a busca.");	
		return;
	} // end if	
	
	// Check if createdAt From and To are filled 
	if (filterByCreateAtFrom || filterByCreateAtTo) {
		if (!filterByCreateAtFrom || !filterByCreateAtTo) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("Você precisa preencher ao os dois campos da data de criação para prosseguir.");	
			return;
		}
	} // end if

	// Check if checkinDate From and To are filled 
	if (filterByCheckinDateFrom || filterByCheckinDateTo) {
		if (!filterByCheckinDateFrom || !filterByCheckinDateTo) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("Você precisa preencher ao os dois campos da data do check-in para prosseguir.");	
			return;
		}
	} // end if	

	// Check if checkoutDate From and To are filled 
	if (filterByCheckoutDateFrom || filterByCheckoutDateTo) {
		if (!filterByCheckoutDateFrom || !filterByCheckoutDateTo) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("Você precisa preencher ao os dois campos da data do check-out para prosseguir.");	
			return;
		}
	} // end if	

	// Check if cancellationDeadline From and To are filled 
	if (filterByCancellationDeadlineFrom || filterByCancellationDeadlineTo) {
		if (!filterByCancellationDeadlineFrom || !filterByCancellationDeadlineTo) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("Você precisa preencher ao os dois campos da data do limite de cancelamento para prosseguir.");	
			return;
		}
	} // end if	
	
	// Check company document if ok
	if (filterByCustomerDocument) {
		if (!validarCPF(filterByCustomerDocument)) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("O CPF informado é inválido. Verifique novamente.");		
			return;
		}
	} // end if	

	// Check customer document if ok
	if (filterByAgencyDocument) {
		if (!validarCNPJ(filterByAgencyDocument)) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("O CNPJ informado é inválido. Verifique novamente.");	
			return;
		}
	} // end if		
	 	
	// Set filter on
	setBasicFilterStatus(false);
	
	// Clean Basic Search term
	setFilterValue("");
	
	// Set advanced filter off
	setAdvancedFilterStatus(true);
	
	// Set filter to lazyData
	var currentData = {...lazyState}	
	
	var filters = {};
	filters.mode = "advanced"; 
	filters.reservationId = filterByReservationId ? filterByReservationId : null; 
	filters.agencyName = filterByAgencyName ? filterByAgencyName : null; 
	filters.agencyDocument = filterByAgencyDocument ? filterByAgencyDocument : null; 
	filters.customerName = filterByCustomerName ? filterByCustomerName : null; 
	filters.guestName = filterByGuestName ? filterByGuestName : null; 
	filters.customerDocument = filterByCustomerDocument ? filterByCustomerDocument : null; 
	filters.userName = filterByUserName ? filterByUserName : null; 
	filters.transportType = filterByTransportType ? filterByTransportType : null; 
	filters.createAtFrom = filterByCreateAtFrom ? filterByCreateAtFrom : null; 
	filters.createAtTo = filterByCreateAtTo ? filterByCreateAtTo : null; 
	filters.checkinDateFrom = filterByCheckinDateFrom ? filterByCheckinDateFrom : null; 
	filters.checkinDateTo = filterByCheckinDateTo ? filterByCheckinDateTo : null; 
	filters.checkoutDateFrom = filterByCheckoutDateFrom ? filterByCheckoutDateFrom : null; 
	filters.checkoutDateTo = filterByCheckoutDateTo ? filterByCheckoutDateTo : null; 

	filters.cancellationDeadlineFrom = filterByCancellationDeadlineFrom ? filterByCancellationDeadlineFrom : null;
	filters.cancellationDeadlineTo = filterByCancellationDeadlineTo ? filterByCancellationDeadlineTo : null;

	filters.paymentMethod = filterByPaymentMethod ? filterByPaymentMethod : null; 
	filters.status = filterByBookingStatus ? filterByBookingStatus : null;
	filters.paymentStatus = filterByStatus ? filterByStatus : null; 

	// Apply filter on Data from service 
	let _lazyParams = { ...lazyState, filters:{ fields: filters, mode:"advanced" } };
	setlazyState(_lazyParams);	
	
	// Closes panel
	setAdvancedSearch(!advancedSearch)
	
} // end function
 
/* -------------------------------- */ 
/* Custom methods and options END */
/* -------------------------------- */
 
 
/* -------------------- */ 
/* Common methods START */
/* -------------------- */

// Set selected columns
const onColumnsChange = (e) => {
	
	let _visibleColumns = [...visibleColumns];

	if (e.checked)
		_visibleColumns.push(e.value);
	else
		_visibleColumns.splice(_visibleColumns.indexOf(e.value), 1);

	setVisibleColumns(_visibleColumns);
}

// Datatable related controls START
const loadLazyData = () => {	
	setLoading(true);
	retrieveItemsList();	
};

// Run after mount component
React.useEffect(() => {

	// Retrieve User Data Obj. 
	var result = localStorage.getItem("@dream4/userData", undefined,true);
	var userData = JSON.parse(result);  

	  // If token dont exist, redirect to onboarding or register
	  if (!userData) {
		  navigate("/home");
		  return;
	  } // end if

  // set scroll to top
  window.scrollTo(0, 1);
  setDialog('reservationModal',false);
  
       
  // Runs when UNMOUNT component
  return () => {
    
	setDialog('reservationModal',false);
	
  };
  
}, []); // end useEffect 

// check if have manageUsers right
React.useEffect(() => {

	  const userRight = userRights.includes("listBookings") || userRights.includes("all");
	  if (!userRight) {
		  // redirect to admin home
		  navigate("/order");
		  return;
	  }

}, [dialog]); // end useEffect

const onPage = (event) => {	
	setlazyState(event);
};

const onSort = (event) => {
	setlazyState(event);
};

const onFilter = (event) => {
	event['first'] = 0;
	setlazyState(event);
};
// Datatable related controls END

// Reacts when lazyState changes
React.useEffect(() => {
	loadLazyData();
	handleClickScroll('root');
}, [lazyState]);
 
// Set Currency format
let EURO = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'EUR',
});

// Set Currency format
let USD = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'USD',
});

// Set Currency format
let BRL = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
});

// Set calendar locale
addLocale('br', {
	firstDayOfWeek: 1,
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar'
});

// set Use of history for PUSH 
var navigate = useNavigate(); 


const handleClickScroll = (target,displacement=70) => {
		
	const element = document.getElementById(target);
	if (element) {
		// 👇 Will scroll smoothly to the top of the next section
		var elementPosition = element.offsetTop - displacement;
		element.scrollIntoView({ top: elementPosition,behavior: 'smooth' });
	}
};  

/* -------------------- */ 
/* Common methods END */
/* -------------------- */
 
  return (
	<>
	<div id="adminSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
		<div style={{height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		
			<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start"}}>
						
				<div style={{flex:1,display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"flex-start",gap:"10px",padding:"40px",marginTop:"0px",height:"auto",marginLeft:"auto",marginRight:"auto",width:"100%",border:"0px solid red"}}>
				
						{/* Admin Side Menu */}
						<SideMenu state="open" />
						
						{/* Admin Content */}
						<div style={{flex:1,height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
						
							<div style={{height:"64px",width:"100%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
							
								<div style={{textAlign:"left",flex:1,color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '36px', fontStyle: 'normal', fontWeight: 600, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Reservas</div>
								
								<div style={{flex:3,display:"flex",flexDirection:"row",justifyContent:"end",alignItems:"center"}}>
								
									<div style={{padding:"10px",marginRight:"10px",fontSize:"14px"}}>  Filtrar a busca por: </div>
									<div style={{backgroundColor:"#FFF",padding:"10px",borderTopLeftRadius:"20px",borderBottomLeftRadius:"20px"}}> 
										<Dropdown id="filterOption" disabled={saving} value={filter} onChange={(e) => setFilter(e.value)} options={dropdownFilterItems} optionLabel="name" placeholder="Selecione o campo" style={{minWidth:isSpecialDesktop ? "200px" : "230px",textAlign:"left",fontSize:"14px"}} className="w100"></Dropdown>
									</div>
									<div style={{backgroundColor:"#FFF",padding:"10px"}}> 
										<div style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
											<InputText id="filterValue" autoComplete="new-password" disabled={saving}  value={filterValue} onChange={(e) => setFilterValue(e.target.value)} placeholder="Termo da busca" tooltip="Digite o termo a ser buscado" tooltipOptions={{position: 'bottom',event: 'focus'}}  style={{borderTopRightRadius:0,borderBottomRightRadius:0,fontSize:"14px"}} />
											<Button labell="Buscar" icon="pi pi-search" style={{borderTopLeftRadius:0,borderBottomLeftRadius:0,height:"47px",fontSize:"14px"}} loading={saving} onClick={()=>{applyBasicSearch()}} />
											 
											{basicFilterStatus &&
											<>
												<Button outlined icon="pi pi-times" style={{height:"47px",fontSize:"14px",marginLeft:"5px"}} loading={saving} tooltip="Selecione para limpar a busca" tooltipOptions={{ showDelay: 500, position: 'bottom',event: 'over'}} onClick={()=>resetSearch("basic")} />
											</>
											}
											
									  </div>							
									</div>									
									<div style={{backgroundColor:"#FFF",padding:"10px"}}> 
										<Button className="filterButton" badge={advancedFilterStatus ? <svg viewBox="0 0 24 24" width="12" height="12" style={{position:"absolute",right:"2px",top:"2px"}} fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCaredrediered" stredoke-width="0"></g><g id="SVGRepo_tredaceredCaredrediered" stredoke-linecap="redound" stredoke-linejoin="redound"></g><g id="SVGRepo_iconCaredrediered"> <path d="M19 3H5C3.58579 3 2.87868 3 2.43934 3.4122C2 3.8244 2 4.48782 2 5.81466V6.50448C2 7.54232 2 8.06124 2.2596 8.49142C2.5192 8.9216 2.99347 9.18858 3.94202 9.72255L6.85504 11.3624C7.49146 11.7206 7.80967 11.8998 8.03751 12.0976C8.51199 12.5095 8.80408 12.9935 8.93644 13.5872C9 13.8722 9 14.2058 9 14.8729L9 17.5424C9 18.452 9 18.9067 9.25192 19.2613C9.50385 19.6158 9.95128 19.7907 10.8462 20.1406C12.7248 20.875 13.6641 21.2422 14.3321 20.8244C15 20.4066 15 19.4519 15 17.5424V14.8729C15 14.2058 15 13.8722 15.0636 13.5872C15.1959 12.9935 15.488 12.5095 15.9625 12.0976C16.1903 11.8998 16.5085 11.7206 17.145 11.3624L20.058 9.72255C21.0065 9.18858 21.4808 8.9216 21.7404 8.49142C22 8.06124 22 7.54232 22 6.50448V5.81466C22 4.48782 22 3.8244 21.5607 3.4122C21.1213 3 20.4142 3 19 3Z" fill="#FFF"></path> </g></svg> : ""} badgeClassName={advancedFilterStatus ? "p-badge-secondary" : "hidden"} icon={<svg viewBox="0 0 24 24" height="24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M14 4C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V13M10 4C6.22876 4 4.34315 4 3.17157 5.17157C2 6.34315 2 8.22876 2 12C2 15.7712 2 17.6569 3.17157 18.8284C4.34315 20 6.22876 20 10 20H13" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M10 16H6" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <circle cx="18" cy="17" r="3" stroke="#814DE5" stroke-width="1.5"></circle> <path d="M20.5 19.5L21.5 20.5" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M2 10L7 10M22 10L11 10" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>} outlined severity="secondary" aria-label="Busca avançada" style={{height:"47px", width:"40px",fontSize:"14px"}} onClick={()=>setAdvancedSearch(!advancedSearch)} /> 
										
										<Button icon={<svg viewBox="0 0 24 24" height="24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M9 4V20M15 4V20M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>} outlined severity="secondary" aria-label="Busca avançada" style={{marginLeft:"10px",height:"47px", width:"40px",fontSize:"14px"}} onClick={(e) => op.current.toggle(e)} />
										<OverlayPanel ref={op} style={{zIndex:"9999"}}>

										<div className="card flex flex-wrap justify-content-center gap-3" style={{display:"flex",flexDirection:"column",alignItems:"flex-start",justifyContent:"center",gap:"10px",padding:"15px"}}>

											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column1" name="reservationId" value="reservationId" onChange={onColumnsChange} disabled={true} checked={visibleColumns.includes('reservationId')} />
												<label htmlFor="column1" className="ml-2">Nº da reserva</label>
											</div>
											
											{masterUser &&
												<>
												<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
													<Checkbox inputId="column2" name="agency" value="agency" onChange={onColumnsChange} checked={visibleColumns.includes('agency')} />
													<label htmlFor="column2" className="ml-2">Agência</label>
												</div>
												</>
											}
											
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column3" name="user" value="user" onChange={onColumnsChange} checked={visibleColumns.includes('user')} />
												<label htmlFor="column3" className="ml-2">Usuário</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column4" name="customer" value="customer" onChange={onColumnsChange} checked={visibleColumns.includes('customer')} />
												<label htmlFor="column4" className="ml-2">Cliente</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column5" name="locality" value="locality" onChange={onColumnsChange} checked={visibleColumns.includes('locality')} />
												<label htmlFor="column5" className="ml-2">Local</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column6" name="createdAt" value="createdAt" onChange={onColumnsChange} checked={visibleColumns.includes('createdAt')} />
												<label htmlFor="column6" className="ml-2">Criada em</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column7" name="checkinDate" value="checkinDate" onChange={onColumnsChange} checked={visibleColumns.includes('checkinDate')} />
												<label htmlFor="column7" className="ml-2">Data de Checkin</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column10" name="checkoutDate" value="checkoutDate" onChange={onColumnsChange} checked={visibleColumns.includes('checkoutDate')} />
												<label htmlFor="column10" className="ml-2">Data de Checkout</label>
											</div>											
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column11" name="payment" value="payment" onChange={onColumnsChange} checked={visibleColumns.includes('payment')} />
												<label htmlFor="column11" className="ml-2">Pagamento</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column9" name="status" value="status" onChange={onColumnsChange} checked={visibleColumns.includes('status')} />
												<label htmlFor="column9" className="ml-2">Status</label>
											</div>											
											
										</div>

										</OverlayPanel> 	

										{/*<Button icon={<svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M12 14L12 4M12 4L15 7M12 4L9 7" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>	} outlined severity="secondary" aria-label="Adicionar usuário" style={{marginLeft:"10px",height:"47px", width:"40px",fontSize:"14px"}} onClick={(e) => console.log("EXPORT TO EXCEL")} />*/}		

										{(!masterUser && (userRights.includes("payMultipleBookings") || userRights.includes("all"))) &&
										<>
											<Button icon={<img src={multiPaymentsIcon} style={{padding:"0.2rem",width:"24",height:"auto"}} />} outlined severity="secondary" aria-label="Pagar mais de uma reserva" style={{marginLeft:"10px",height:"47px", width:"40px",fontSize:"14px"}} onClick={(e) => payMultipleBooking(e)} />
										</>
										}

									</div>
								
								</div>
							
							</div>

							<div className={!advancedSearch ? "advSearchPanel" : "advSearchPanel animate"} style={{width:"100%",backgroundColor:"whitesmoke",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-start",padding:advancedSearch ? "25px" : "0px"}}>
								
								<div style={{textAlign:"left",color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '26px', fontStyle: 'normal', fontWeight: 600, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Busca avançada</div>
								<div style={{textAlign:"left",color: '#000', fontFamily: 'Titillium Web', fontSize: '16px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',paddingTop:"0px",marginBottom:"35px"}}>Preencha um ou mais campos e faça a busca</div>

								<Grid container spacing={4}>
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label">
										<InputText value={filterByReservationId} onChange={(e) => setFilterByReservationId(e.target.value)} id="filterByReservationId" autoComplete="new-password" className="w100" tooltip="Apenas números" tooltipOptions={{ position: 'bottom',event: 'focus' }} />
										<label htmlFor="filterByReservationId">Número interno <span className="requiredField">*</span></label>
									</span>
								  </Grid>
								  
								{masterUser &&
								<>							  
								  
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label">
										<InputText value={filterByAgencyName} onChange={(e) => setFilterByAgencyName(e.target.value)} id="filterByAgencyName" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByAgencyName">Nome da Agência</label>
									</div>
								  </Grid>

								  <Grid item xs={12} sm={4}>
									<div className="p-float-label">
										<InputText  value={filterByAgencyDocument} onChange={(e) => setFilterByAgencyDocument(maskCNPJ(e.target.value))}  onBlur={(e) => setFilterByAgencyDocument(maskCNPJ(e.target.value))} id="filterByAgencyDocument" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByAgencyDocument">CNPJ da Agência</label>
									</div>
								  </Grid>
								  
								  </>
								}
								  
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label">
										<InputText  value={filterByCustomerName} onChange={(e) => setFilterByCustomerName(e.target.value)} id="filterByCustomerName" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByCustomerName">Nome do cliente (responsável pelo pagamento)</label>
									</div>
								  </Grid>

								  <Grid item xs={12} sm={4}>
									<div className="p-float-label">
										<InputText  value={filterByGuestName} onChange={(e) => setFilterByGuestName(e.target.value)} id="filterByGuestName" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByGuestName">Nome do hóspede</label>
									</div>
								  </Grid>

								  <Grid item xs={12} sm={4}>
									<span className="p-float-label" >
										<InputText  value={filterByCustomerDocument} onChange={(e) => setFilterByCustomerDocument(maskCPF(e.target.value))} onBlur={(e) => setFilterByCustomerDocument(maskCPF(e.target.value))} id="filterByCustomerDocument" autoComplete="new-password" style={{width:"100%"}} />
										<label htmlFor="filterByCustomerDocument">CPF do cliente <span className="requiredField">*</span></label>
									</span>		
								  </Grid>								  
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label">
										<InputText  value={filterByUserName} onChange={(e) => setFilterByUserName(e.target.value)} id="filterByUserName" autoComplete="new-password"  className="w100" />
										<label htmlFor="filterByUserName">Nome do Usuário<span className="requiredField">*</span></label>
									</span>
								  </Grid>
								  {/*<Grid item xs={12} sm={4}>
									<div className="p-float-label" style={{textAlign:"left"}}>
										<MultiSelect showClear value={filterByTransportType} onChange={(e) => setFilterByTransportType(e.target.value)} options={[{"code":1,name:"Trem"},{"code":2,name:"Ônibus"},{"code":3,name:"Aluguel de Carro"},{"code":4,name:"Transfer"}]} optionLabel="name" placeholder="Selecione o tipo de transporte" className="w100" display="chip"></MultiSelect>
										<label>Local</label>
									</div>									
								  </Grid>*/}
								  <Grid item xs={12} sm={4} style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
									<span className="p-float-label" style={{width:"49%",marginRight:"5px"}}>
										<Calendar value={filterByCreateAtFrom} onChange={(e) => setFilterByCreateAtFrom(e.target.value)} showButtonBar locale="br"  id="fromDate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Criada de <span className="requiredField">*</span></label>
									</span>										
									<span className="p-float-label" style={{width:"49%"}}>
										<Calendar value={filterByCreateAtTo} onChange={(e) => setFilterByCreateAtTo(e.target.value)} showButtonBar locale="br"  id="todate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Criada até <span className="requiredField">*</span></label>
									</span>										
								  </Grid>

								  <Grid item xs={12} sm={4} style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
									<span className="p-float-label" style={{width:"49%",marginRight:"5px"}}>
										<Calendar value={filterByCheckinDateFrom} onChange={(e) => setFilterByCheckinDateFrom(e.target.value)} showButtonBar locale="br"  id="fromDate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Dt Checkin de <span className="requiredField">*</span></label>
									</span>										
									<span className="p-float-label" style={{width:"49%"}}>
										<Calendar value={filterByCheckinDateTo} onChange={(e) => setFilterByCheckinDateTo(e.target.value)} showButtonBar locale="br"  id="todate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Dt Checkin até <span className="requiredField">*</span></label>
									</span>										
								  </Grid>
								  
								  <Grid item xs={12} sm={4} style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
									<span className="p-float-label" style={{width:"49%",marginRight:"5px"}}>
										<Calendar value={filterByCheckoutDateFrom} onChange={(e) => setFilterByCheckoutDateFrom(e.target.value)} showButtonBar locale="br"  id="fromDate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Dt Checkout de <span className="requiredField">*</span></label>
									</span>										
									<span className="p-float-label" style={{width:"49%"}}>
										<Calendar value={filterByCheckoutDateTo} onChange={(e) => setFilterByCheckoutDateTo(e.target.value)} showButtonBar locale="br"  id="todate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Dt Checkout até <span className="requiredField">*</span></label>
									</span>										
								  </Grid>
								  
								  <Grid item xs={12} sm={4} style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
									<span className="p-float-label" style={{width:"49%",marginRight:"5px"}}>
										<Calendar value={filterByCancellationDeadlineFrom} onChange={(e) => setFilterByCancellationDeadlineFrom(e.target.value)} showButtonBar locale="br"  id="fromDate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Limite Cancel. de <span className="requiredField">*</span></label>
									</span>										
									<span className="p-float-label" style={{width:"49%"}}>
										<Calendar value={filterByCancellationDeadlineTo} onChange={(e) => setFilterByCancellationDeadlineTo(e.target.value)} showButtonBar locale="br"  id="todate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Limite Cancel. até <span className="requiredField">*</span></label>
									</span>										
								  </Grid>
								  

								  <Grid item xs={12} sm={4}>	
									<div className="p-float-label" style={{textAlign:"left"}}>
										<Dropdown showClear value={filterByPaymentMethod} onChange={(e) => setFilterByPaymentMethod(e.target.value)} options={[{"code":"cc",name:"Cartão de Crédito"},{"code":"pix",name:"PIX"}]} optionLabel="name" placeholder="Selecione a forma de pagamento" className="w100"></Dropdown>
										<label>Forma de Pagamento</label>
									</div>									
								  </Grid>
								 
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label" style={{textAlign:"left"}}>
										<Dropdown showClear value={filterByStatus} onChange={(e) => setFilterByStatus(e.target.value)} options={[{"code":0,name:"Aguardando Pagamento"},{"code":1,name:"Pagamento Confirmado"},{"code":3,name:"Aguardando estorno"},{"code":4,name:"Estorno confirmado"}]} optionLabel="name" placeholder="Selecione o Status" className="w100"></Dropdown>
										<label>Status do pagamento</label>
									</div>										
								  </Grid>					 	  

								  <Grid item xs={12} sm={4}>
									<div className="p-float-label" style={{textAlign:"left"}}>
										<MultiSelect showClear value={filterByBookingStatus} onChange={(e) => setFilterByBookingStatus(e.target.value)} options={[{"code":0,name:"Aguardando confirmação"},{"code":1,name:"Confirmada"},{"code":2,name:"Cancelada pelo sistema"},{"code":3,name:"Cancelada pela agência"}]} optionLabel="name" placeholder="Selecione o Status da reserva" className="w100" />
										<label>Status da reserva</label>
									</div>										
								  </Grid>					 	  								  

								  <Grid item xs={12} sm={12}>
									<div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center",gap:"20px"}}> 
									
											<div style={{textAlign:"right",flex:1}}>
												<Button label="Limpar busca" icon="pi pi-trash" severity="danger" text onClick={()=>{resetSearch("advanced");setAdvancedSearch(!advancedSearch)}}  />
											</div>												
											
											<Button rounded outlined className="pT10" label="Fechar" onClick={()=>setAdvancedSearch(!advancedSearch)} />
																				
											<Button rounded className="pT10" label="Buscar" loading={saving} disabled={saving} onClick={()=>{applyAdvancedSearch()}} />		
									</div>
								  </Grid>
								  
								</Grid>							  

							</div>

							<div style={{flex:1,width:"100%",backgroundColor:"#FFF"}}>
							
								<div className="card" style={{minHeight:"66vh",zIndex: 8,position:"relative"}}>

									<DataTable selectionMode="rowClick"		
									lazy onPage={onPage}  emptyMessage="Nenhuma reserva encontrada."
									size="small"
									first={lazyState.first}    
									onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
									onFilter={onFilter} filters={lazyState.filters} loading={loading} totalRecords={totalRecords}									
									reorderableColumns reorderableRows stripedRows 
									paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink  RowsPerPageDropdown"
									currentPageReportTemplate="{first} to {last} of {totalRecords}"
									onSelectionChange={!masterUser ? (e) => handleRowCheckboxChange(e.value) : (e)=>selectReservationAction(e.value)} value={rows} paginator rows={lazyState.rows} rowsPerPageOptions={[10, 25, 50, 100]} tableStyle={{ minWidth: '50rem',fontSize:"0.85rem"}}>
		
										{/* Fixed column */}
										<Column fields="selectCheckbox" headerStyle={{ width: '3rem' }} body={(data)=>bodyTemplate('selectionCheckbox',data)}></Column>
										
										<Column field="reservationId" header="Nº interno" body={(data)=>bodyTemplate('reservationId',data)}></Column>
										
										{/* Dinamic columns */}
										{visibleColumns.map((col) => { 

											if (col == 'agency' && masterUser) {
												return(<Column style={{ maxWidth: '10rem' }}  field="agency.name" header="Agência" sortable body={(data)=>bodyTemplate('agency',data.agency)}></Column>)
											}

											if (col == 'user') {
												return(<Column style={{ maxWidth: '7rem' }} field="employee.name" header="Usuário" sortable  body={(data)=>bodyTemplate('employee',data.employee)}></Column>)
											}											

											if (col == 'customer') {
												return(<Column style={{ maxWidth: '8rem' }}  field="customer.name" header="Cliente" sortable body={(data)=>bodyTemplate('customer',data.customer)}></Column>)
											}
											
											if (col == 'locality') {
												return(<Column style={{ maxWidth: '10rem' }} field="locality" header="Local" body={(data)=>bodyTemplate('locality',data)}></Column>)
											}
											
											if (col == 'checkinDate') {
												return(<Column style={{ maxWidth: '6rem' }} field="checkinDate" header="Checkin" sortable body={(data)=>bodyTemplate('checkinDate',data)}></Column>)
											}
											
											if (col == 'checkoutDate') {
												return(<Column style={{ maxWidth: '6rem' }} field="checkoutDate" header="Checkout" sortable body={(data)=>bodyTemplate('checkoutDate',data)}></Column>)
											}
											
											if (col == 'payment') {
												return(<Column  style={{ minWidth: '8rem' }} field="payment" header="Valor" body={(data)=>bodyTemplate('payment',data)}></Column>)
											}											

											if (col == 'createdAt') {
												return(<Column style={{ maxWidth: '6rem' }}  field="createdAt" header="Criada em" sortable body={(data)=>bodyTemplate('creationDate',data)}></Column>)
											}

											if (col == 'status') {
												return(<Column  style={{ maxWidth: '10rem' }} field="status" header="Status" body={(data)=>bodyTemplate('status',data)}></Column>)
											}

										})}
										
										{!masterUser && <Column style={{ maxWidth: '6rem' }} field="actions" header="Ações" body={(data)=>bodyTemplate('actions',data)}></Column>}
										
									</DataTable>

								</div>							
							
							</div>
						
						</div>
						
				</div>
			
			</div> 
		</div>
		
		<ConfirmDialog className="paymentConfirm" />

		<ReservationView
			setDialog={setDialog}
			dialog={dialog}
			scrollBlock={false}
			onReloadDataList={retrieveItemsList}
		/>			

		<ReservationMultiPayView
			setDialog={setDialog}
			dialog={dialog}
			scrollBlock={false}
			onReloadDataList={retrieveItemsList}
			selectedBookingsStore={selectedBookingsStore}

			setAlert={setAlert}
			setAlertTitle={setAlertTitle}
			setAlertBody={setAlertBody}	
			
			resetSelection={resetSelection}
			key={selectedBookingsStore[0]?.reservationId || 'new'}
		/>			

		<AlertView
			alert={alert}
			setAlert={setAlert}
			alertTitle={alertTitle}
			alertBody={alertBody}	
			scrollBlock={false}				
		/>

    </div>
	
	{/* Contac Us Section */}
	<ContactUs />		

	{/* About Us Section */}
	<AboutUs />
	
	</>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser,
  userRights:store.appReducer.userRights,
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions,...ReservationActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(Reservation);	


